import React from 'react';
import { Link } from 'react-router-dom';
import { CornerDecoration } from '@components/common';
import '@styles/placeholder.css';
import './ConsolesPage.css';

const ConsolesPage: React.FC = () => {
  return (
    <section className="page-section placeholder-section">
      <div className="placeholder-container">
        <h1 className="placeholder-title">Consoles & Emulators</h1>

        <div className="placeholder-icon">
          <span className="icon-symbol">🎮</span>
        </div>

        <p className="placeholder-description">
          Play your favorite retro games with our curated collection of emulators
          for every platform imaginable.
        </p>

        <div className="cloud-archive-card">
          <h2 className="cloud-archive-card__title">
            <span className="cloud-archive-card__icon">☁️</span>
            Emulator Collection
          </h2>
          <p className="cloud-archive-card__description">
            Access our complete emulator library through cloud storage.
            From classic consoles to arcade machines, we've got you covered.
          </p>
          <a
            href="https://mega.nz/folder/57UggRJI#2Jqw1A_pzU4WgjZS6vi35w"
            target="_blank"
            rel="noopener noreferrer"
            className="cloud-archive-card__link"
          >
            Open MEGA Archive
          </a>
          <p className="cloud-archive-card__stats">
            200+ emulators available
          </p>
        </div>

        <nav className="nav-links">
          <Link to="/" className="nav-link">Home</Link>
          <Link to="/games" className="nav-link">Games</Link>
          <Link to="/donate" className="nav-link">Donate</Link>
        </nav>
      </div>

      <CornerDecoration />
    </section>
  );
};

export default ConsolesPage;
